"use client"

import LandingPageRework from "./landing-page-rework/page"

export default function App() {
  return <LandingPageRework />
}
